import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that resets focus on navigation changes
 * This ensures that when a user navigates to a new page while using keyboard navigation,
 * any focused element is blurred and focus is reset to the skip-to-content link
 */
const FocusReset = () => {
  const location = useLocation();
  const isUsingKeyboard = useRef(false);

  // Track keyboard usage
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        isUsingKeyboard.current = true;
      }
    };

    const handleMouseDown = () => {
      isUsingKeyboard.current = false;
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  useEffect(() => {
    // Only reset focus if user is navigating with keyboard
    if (isUsingKeyboard.current && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();

      console.log('focus reset - keyboard navigation detected');

      // Reset focus to the skip-to-content element
      // Using setTimeout to ensure this happens after the DOM has updated
      setTimeout(() => {
        const skipToContentElement = document.getElementById('skip-to-content');
        if (skipToContentElement) {
          skipToContentElement.focus();
        } else {
          // Fallback to body if skip-to-content doesn't exist
          document.body.focus();
        }
      }, 0);
    }
  }, [location.pathname]);

  return null;
};

export default FocusReset;
